import * as yup from "yup";
import type { FormSchema } from "@/models/form";
import useValidation from "@/use/validation";

export default function useNameFieldValidationSchemas(schema: FormSchema) {
  const { getErrorMessage } = useValidation();

  const firstNameValidationSchema = yup
    .string()
    .label(schema?.firstName?.label || "First Name")
    .transform((curr, orig) => (orig === "" ? undefined : curr))
    .required(getErrorMessage(schema.firstName))
    .test(
      "valid-input",
      `${
        schema.firstName?.label || "First Name"
      } can only contain letters, apostrophes, hyphens, and spaces.`,
      (value) => {
        const validInput = /^[a-zA-Z\s'-]+$/.test(value);
        return validInput;
      }
    );

  const middleNameValidationSchema = yup
    .string()
    .label(schema?.middleName?.label || "Middle Name")
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .test(
      "valid-input",
      `${schema?.middleName?.label || "Middle Name"} can only contain letters, apostrophes, hyphens, and spaces.`,
      (value) => {
        if (value === undefined || value === null) {
          return true;
        }
        const validInput = /^[a-zA-Z\s'-]+$/.test(value);
        return validInput;
      }
    );

  const lastNameValidationSchema = yup
    .string()
    .label(schema?.lastName?.label || "Last Name")
    .required(getErrorMessage(schema.lastName))
    .transform((curr, orig) => (orig === "" ? undefined : curr))
    .test(
      "valid-input",
      `${
        schema?.lastName?.label || "Last Name"
      } can only contain letters, apostrophes, hyphens, and spaces.`,
      (value) => {
        const validInput = /^[a-zA-Z\s'-]+$/.test(value);

        return validInput;
      }
    );

  return {
    firstNameValidationSchema,
    middleNameValidationSchema,
    lastNameValidationSchema,
  };
}
